import { render } from "./AlumniList.vue?vue&type=template&id=670abdde&scoped=true"
import script from "./AlumniList.vue?vue&type=script&lang=js"
export * from "./AlumniList.vue?vue&type=script&lang=js"

import "./AlumniList.vue?vue&type=style&index=0&id=670abdde&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-670abdde"]])

export default __exports__